export default {
  'search.placeholder': 'Search by name, location, services...',
  'search.results': '{{count}} profiles',
  'search.no_results': 'No results found for "{{query}}"',
  'search.clear': 'Clear search',
  'search.showing': 'Showing',
  'search.showing_results': 'Results for "{{query}}"',
  'search.showing_all': 'Showing all profiles',
  'search.results_for': 'results for',
  'search.and': 'and',
  'search.with_filters': 'with {{count}} active filters',
  'search.active_filters': 'active filters',
  'search.no_profiles_found': 'No profiles found',
  'search.no_profiles_message': 'We couldn\'t find any profiles right now. Please try again later or adjust your search criteria.',
  'search.try_again': 'Please try another search term or browse all profiles.',
  'search.filter_results': 'Filter Results',
  'search.reset_filters': 'Reset Filters',
  'search.all_genders': 'All Genders',
  'search.min_age': 'Min Age',
  'search.max_age': 'Max Age',
  'search.status': 'Status',
  'search.verified_only': 'Verified Only',
  'search.online_only': 'Online Only',
  'search.search_placeholder': 'Search by name, location, services...',
  'search.filters': 'Filters',
};
